<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';

const props = defineProps({
  group: { type: Object, required: true },
});

const { t } = useI18n();
const title = computed(() => {
  if (props.group.role === 'vendedor') {
    return t('SALES.DELIVERY.EMAILS.VENDEDORES');
  }

  return t('SALES.DELIVERY.EMAILS.COMPRADORES');
});
const physicalLabel = computed(() => {
  if (props.group.physicalCount === 1) {
    return t('SALES.DELIVERY.EMAILS.PHYSICAL_ONE', {
      count: props.group.physicalCount,
    });
  }

  return t('SALES.DELIVERY.EMAILS.PHYSICAL_MANY', {
    count: props.group.physicalCount,
  });
});
const companyLabel = computed(() => {
  if (props.group.companyCount === 1) {
    return t('SALES.DELIVERY.EMAILS.COMPANY_ONE', {
      count: props.group.companyCount,
    });
  }

  return t('SALES.DELIVERY.EMAILS.COMPANY_MANY', {
    count: props.group.companyCount,
  });
});
const documentLabel = participant =>
  participant.document_type === 'cnpj'
    ? t('SALES.DELIVERY.EMAILS.CNPJ')
    : t('SALES.DELIVERY.EMAILS.CPF');
</script>

<template>
  <LaisCard :title="title" density="tight">
    <div class="mb-3 flex flex-wrap gap-2">
      <span
        class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs text-lais-text-muted"
      >
        {{ physicalLabel }}
      </span>
      <span
        class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs text-lais-text-muted"
      >
        {{ companyLabel }}
      </span>
    </div>
    <div v-if="group.participants.length" class="grid gap-3">
      <article
        v-for="participant in group.participants"
        :key="participant.id"
        class="rounded-lais-sm border border-lais-border-soft bg-lais-bg-soft px-3 py-2"
      >
        <div class="flex flex-wrap items-start justify-between gap-2">
          <div>
            <p class="font-semibold text-lais-text">{{ participant.name }}</p>
            <p class="text-xs text-lais-text-muted">
              {{
                t('SALES.DELIVERY.EMAILS.DOCUMENT', {
                  label: documentLabel(participant),
                  value:
                    participant.document_number ||
                    t('SALES.DELIVERY.EMAILS.EMPTY'),
                })
              }}
            </p>
          </div>
          <p
            v-if="participant.kind === 'pessoa_fisica'"
            class="text-sm text-lais-text-muted"
          >
            {{ participant.email || t('SALES.DELIVERY.EMAILS.EMPTY') }}
          </p>
        </div>
        <div
          v-if="participant.representatives?.length"
          class="mt-3 grid gap-2 border-l-2 border-lais-border pl-3"
        >
          <div
            v-for="representative in participant.representatives"
            :key="representative.id"
            class="flex flex-wrap justify-between gap-2 text-sm"
          >
            <span class="font-semibold text-lais-text">{{
              representative.name
            }}</span>
            <span class="text-lais-text-muted">
              {{ representative.email || t('SALES.DELIVERY.EMAILS.EMPTY') }}
            </span>
          </div>
        </div>
      </article>
    </div>
    <p v-else class="text-sm text-lais-text-muted">
      {{ t('SALES.DELIVERY.EMAILS.NO_RECIPIENTS') }}
    </p>
  </LaisCard>
</template>
